module.exports = __webpack_public_path__ + "static/media/0029_IMG_LE_SOL_MEGALITH_MEGABROWN.42357ace.webp";